export type PaymentStatus =
  | 'PENDING'
  | 'SUCCESS'
  | 'FAILED'
  | 'EXPIRED'
  | 'CANCELED'
  | 'NEEDS_REVIEW'
  | 'REFUNDED';

export const PAYMENT_STATUSES: PaymentStatus[] = [
  'PENDING',
  'SUCCESS',
  'NEEDS_REVIEW',
  'FAILED',
  'EXPIRED',
  'CANCELED',
  'REFUNDED',
];

export interface PaymentRow {
  publicId: string;
  status: PaymentStatus;
  kind: string;
  amountMinor: number;
  listAmountMinor: number;
  discountMinor: number;
  coupon: { code: string } | null;
  currency: string;
  invoiceNumber: string | null;
  createdAt: string | null;
  expiresAt: string | null;
  paidAt: string | null;
  item: { publicId: string; name: string } | null;
  user: { publicId: string; email: string };
}

export interface IpnEvent {
  publicId: string;
  status: string;
  notificationType: string;
  createdAt: string | null;
  processedAt: string | null;
  error: string | null;
  rawPayload: unknown;
}

export interface PaymentDetail extends PaymentRow {
  paidAmountMinor: number | null;
  externalRef: string | null;
  sepayOrderId: string | null;
  checkoutUrl: string | null;
  metadata: Record<string, unknown> | string | null;
  ipnEvents: IpnEvent[];
}

export interface PaymentListParams {
  page: number;
  limit: number;
  status?: PaymentStatus | '';
  kind?: string;
  q?: string;
  from?: string;
  to?: string;
}

export interface PaymentListResult {
  items: PaymentRow[];
  page: number;
  limit: number;
  total: number;
}

export interface ReconcileResult {
  outcome: { status: string; settled: boolean; reason?: string };
  payment: PaymentRow | null;
}
